export namespace ImageUpload {
  const baseUrl = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/sizes`;

  export function getImageByType(type: Enum) {
    switch (type) {
      case Enum.AffiliateBanner:
        return `${baseUrl}/affiliates-size.png`;
      case Enum.AffiliateCard:
        return `${baseUrl}/affiliates-win-size.png`;
      case Enum.Bonus:
        return `${baseUrl}/bonus-size.png`;
      case Enum.Game:
        return `${baseUrl}/games-size.png`;
      case Enum.Home:
        return `${baseUrl}/home-size.png`;
      case Enum.Tournament:
        return `${baseUrl}/tournaments-size.png`;
      case Enum.VipClub:
        return `${baseUrl}/vip-club-size.png`;
      default:
        return null;
    }
  }

  export enum Enum {
    AffiliateBanner = 'affiliate_banner',
    AffiliateCard = 'affiliate_card',
    Bonus = 'bonus',
    Game = 'game',
    Home = 'home',
    Tournament = 'tournament',
    VipClub = 'vip_club',
  }
}
